import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../../services/auth.service';
import { ReportableService } from '../../../../services/reportable.service';
import { Router, ActivatedRoute } from '@angular/router';
import { DistributionReportService } from '../../../../services/distribution-report.service';
import { CheckUserType } from '../../../../models/checkUserType';
import * as moment from 'moment';
import { AuditOpeningStockCylsService } from '../../../../services/audit-opening-stock-cyls.service';

@Component({
  selector: 'app-audit-chart',
  templateUrl: './audit-chart.component.html',
  styleUrls: ['./audit-chart.component.css']
})
export class AuditChartComponent implements OnInit {
  role = new CheckUserType();
  client;
  distribution_Id: number;
  headlineDetails = Array<any>();

  //Tablet Vars
  chartData: any[];
  colorScheme = {};
  invalidData = false;

  TableTitle: string = 'Status';
  yAxisLabel: string = "# of Cylinders";
  xAxisLabel: string = "Product Types";

  constructor(authService: AuthService, public distributionReportService: DistributionReportService,
    public reportableService: ReportableService, public router: Router, private route: ActivatedRoute, public auditOpeningStockCylsService: AuditOpeningStockCylsService) {
    this.client = authService.currentUser.value;
    this.role.initClient(this.client.role);

    this.distribution_Id = this.route.snapshot.queryParams.distribution_Id;

    this.auditOpeningStockCylsService.getHeadlineDetails(this.distribution_Id).then((details) => {

      const dateStart = moment(details[0].startTime, "YYYY-MM-DDTHH:mm:ss");
      const dateFinish = moment(details[0].finishTime, "YYYY-MM-DDTHH:mm:ss");
      details[0].textDateStart = dateStart.format("DD MMMM YYYY");
      details[0].startTime = dateStart.format("h:mm A");
      details[0].textDateFinish = dateFinish.format("DD MMMM YYYY");
      details[0].finishTime = dateFinish.format("h:mm A");
      this.headlineDetails = details[0];

    });

    distributionReportService.getAuditChart(this.distribution_Id).then((data) => {
      console.log("TTTTTTTTTTTTTTTT");
      this.chartData = data.columns;

      if (this.chartData == undefined || this.chartData == null || this.chartData.length == 0) {
        this.invalidData = true;
      }

      this.colorScheme = {
        domain: ['#0066b8', '#b80000', '#00b834', '#5300b8']
      };
    });

  }

  ngOnInit() {} 

}

